"use client";

import { cn } from "@/lib/utils";
import { ThumbsUpIcon } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";

type TFeedPostLikeButtonProps = {
	isLiked?: boolean;
	onClick?: (like: boolean) => Promise<boolean>;
};

const FeedPostLikeButton = ({
	isLiked: initialLikeStatus = false,
	onClick,
}: TFeedPostLikeButtonProps) => {
	const [liked, setLiked] = useState<boolean>(initialLikeStatus);

	const handleLike = async () => {
		const updatedLikeStatus = !liked;
		setLiked(updatedLikeStatus);

		try {
			const updatedLike = await onClick?.(updatedLikeStatus);
			setLiked(!!updatedLike);
		} catch (error) {
			setLiked((prev) => !prev);
			toast.error((error as Error).message);
		}
	};

	return (
		<button
			type="button"
			onClick={handleLike}
			className={cn(
				"flex w-full items-center justify-center gap-1 rounded-lg border px-4 py-2 text-sm font-semibold disabled:cursor-not-allowed disabled:bg-gray-100 disabled:opacity-75",
				liked ? "border-brand-primary text-brand-primary" : "border-gray-300 text-gray-600"
			)}
		>
			<ThumbsUpIcon className="h-4 w-4" />

			<span>Like</span>
		</button>
	);
};

export default FeedPostLikeButton;
